// extracted by mini-css-extract-plugin
export default {"aspectvideo":"videoStyle_aspectvideo__PoEy0"};